import React, { Component } from 'react'
import { Modal, Button } from 'react-bootstrap';
import { connect } from 'react-redux';

import Loader from "components/elements/loader/Loader";
import { showWarningMessage } from "reducers/application/applicationActions";
import classNames from 'classnames';

class PasswordModal extends Component {

    constructor(props) {
        super(props);
        this.state = {
            password: "",
            passwordError: null
        }
    }

    validate = () => {
        if (this.state.password == null || this.state.password === "") {
            this.props.showWarningMessage("Por favor ingrese una contraseña");
            this.setState({ passwordError: "Por favor ingrese una contraseña" });
            return false;
        }

        return true;
    }

    save = () => {
        if (this.validate()) {
            this.props.save(this.state.password)
        }
    }

    onInputChange(evt) {
        if (evt.target.value !== "") {
            this.setState({ passwordError: null })
        }
        this.setState({ password: evt.target.value });
    }

    render() {
        const { passwordError } = this.state;
        const passwordClass = classNames('form-group',
            { 'has-error': passwordError != null }
        );
        return (
            <Modal
                {...this.props}
                animation={false}
                bsSize="large"
                aria-labelledby="contained-modal-title-sm"
                backdrop={"static"} >
                <Modal.Header>
                    <Modal.Title>Contraseña Requerida</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <form className="form">
                        <div className={passwordClass}>
                            <div className="input-group">
                                <input type="password" className="form-control"
                                    onChange={(evt) => this.onInputChange(evt)}
                                    name="name"
                                    placeholder="Contraseña" />
                            </div>
                            <span className="help-block">{passwordError}</span>
                        </div>
                    </form>
                </Modal.Body>

                <Modal.Footer>
                    {this.props.loading == false ?
                        <div>
                            <Button onClick={this.props.onHide} >Cerrar</Button> &nbsp;
                            <Button onClick={this.save} className="bg-light-secondary">{this.props.buttonLabel}</Button>
                        </div>
                        :
                        <div className="w-100">
                            <Loader classes="password-modal__spinner" show={true} />
                        </div>
                    }
                </Modal.Footer>
            </Modal>
        )
    }
}
const mapStateToProps = state => ({
});
export default connect(
    mapStateToProps,
    { showWarningMessage }
)(PasswordModal);



// WEBPACK FOOTER //
// ./src/components/PasswordModal/PasswordModal.jsx